module.exports = __webpack_public_path__ + "static/media/nonoo.140a6327.png";